export enum FrequencyTypeEnum {
  none = "none",
  weekdays = "weekdays",
}
